module.exports = __webpack_public_path__ + "static/media/welcomeBlogThumbnail.1fc725d7.jpg";